var $ = require("jquery");
require("jquery-selectric");
require('jquery-unslider');
require("jquery-match-height");

$(document).ready(function(){

    var $slider = $('.banner').unslider({
       arrows: false,
       autoplay: true,
       delay: 5000,
       infinite: true
     });

    $slider.on('mouseover', function() {
        $slider.data('unslider').stop();
    }).on('mouseout', function() {
        $slider.data('unslider').start();
    });

    $('select').selectric({
      disableOnMobile: false,
    });

    var slection = $('.select_change');
    slection.hide();
    $('.contact_area').change(function(){
      slection.hide();
      if($(this).val()) {
        var $selected = "." + $(this).val();
        $($selected).show();
      }
    });


    $(".blocks > div").matchHeight();
    $(".post-blocks > div").matchHeight();
    $(".featured-news-post > div").matchHeight();
    $(".service__content > h5").matchHeight();
    $(".service__content > .description").matchHeight();
    $(".match-height").matchHeight();



    $(".js-open-sharebox").click(function(){
      $(".sharebox").toggleClass("active");
    });



    $(".mobile-menu__menu").hide();
    $(".menu-open").show();
    $(".menu-close").hide();
  	$('.mobile-menu__icon').click(function(){
      $(".menu-close").toggle();
      $(".menu-open").toggle();
  		$(".mobile-menu__menu").slideToggle();
  	});

    $(".mobile-nav-item").each(function() {
      if( $(this).is(".menu-item-has-children") && $(this).children(".nav-drop").length > 0 ){
        $(this).children("span").show();
      }
      else{
        $(this).children('span').hide();
      }
    });

  	$('.mobile-nav-item').children('span').click(function(){
      if( $(this).parent().is('.menu-item-has-children') ){
    		$(this).parent().toggleClass('active');
        $(this).toggleClass('active')
    		$(this).siblings('.nav-drop').slideToggle();
      }
  	});

  });
